import { NgModule, ErrorHandler, ChangeDetectionStrategy } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { TokenInterceptorService } from './core/interceptors/token-interceptor.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthHttpService } from './core/services/auth-http/auth-http.service';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { ApiLoadingComponent } from './components/api-loading/api-loading.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { JwtService } from './core/services/jwt/jwt.service';
import { ConnectionAlertComponent } from './shared/components/connection-alert/connection-alert.component';
// import { LoadingInterceptor } from './core/services/loading-services/loading.interceptor';
import { LoadingService } from './core/services/loading-services/loading.service';
import { AuthService } from './core/services/auth/auth.service';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';

class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any) {
    console.error('An unhandled error occurred:', error);
    // You can add more sophisticated error handling here
  }
}
@NgModule({
  declarations: [
    AppComponent,
    ApiLoadingComponent,
    ConnectionAlertComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ConfirmDialogModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ButtonModule,
    ToastModule,
  ],
  providers: [
    provideClientHydration(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
      deps: [AuthHttpService, AuthService, JwtService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
      deps: [LoadingService],
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    MessageService,
    ConfirmationService,
    IdleTimeoutService,
    JwtService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ChangeDetectionStrategy,
      useValue: ChangeDetectionStrategy.OnPush,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
